import { CrossIcon } from '@grupoboticario/flora-react-icons';
import { DrawerWithoutHeader } from './Drawer.components.styles';
import type { DrawerWithoutHeaderProps } from './Drawer.components';

const DrawerWithoutHeaderBase = ({ onDismiss, show }: DrawerWithoutHeaderProps) => (
  <DrawerWithoutHeader.Component data-show={show} onClick={onDismiss} radius="square" size="small">
    <CrossIcon size={24} />
  </DrawerWithoutHeader.Component>
);

export default DrawerWithoutHeaderBase;
